import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 消息提醒类型
 */
class UserMessageType extends UltMeta {
    // All = new Meta(0, "全部");
    TRANSACTION = new Meta(1, "交易");
    TRANSFORM = new Meta(2, "物流");
    OTHER = new Meta(3, "其他");
    NOTIFY = new Meta(4, "通知");
}
export const USER_MESSAGE_TYPE = new UserMessageType();

/**
 * 消息提醒状态
 */
class UserMessageState extends UltMeta {
    UNREAD = new Meta(1, "未读");
    READED = new Meta(2, "已读");
}
export const USER_MESSAGE_STATE = new UserMessageState();

/**
 * 跳转对应详情的常量 UserMessageConstants
 */
export enum UserMessageConstants {
    /**
     * 意向详情
     */
    INTEND_DETAIL_PAGE = "1",
    /**
     * 合同详情
     */
    PROJECT_DETAIL_PAGE = "2",
    /**
     * 项目详情
     */
    STORE_DETAIL_PAGE = "3",
    /**
     * 收款详情
     */
    RECEIPT_DETAIL_PAGE = "4",
    /**
     * 提货单详情
     */
    PURCHASE_GOOD_DETAIL_PAGE = "5",
    /**
     * 签收单详情
     */
    SIGN_IN_DETAIL_PAGE = "6",
    /**
     * 对账详情
     */
    ACCOUNT_DETAIL_PAGE = "7",
    /**
     * 开票详情
     */
    OPEN_INVOICE_DETAIL_PAGE = "8",
    /**
     * 找船需求详情
     */
    FIND_BOAT_DETAIL_PAGE = "9",
    /**
     * 船运单详情
     */
    TRANSFORM_BILL_DETAIL_PAGE = "10",
    /**
     * 承运商船运单详情
     */
    TRANSFER_TRANSFORM_BILL_DETAIL_PAGE = "11",
    /**
     * 报价详情
     */
    GRAP_ORDER_DETAIL_PAGE = "12",
    /**
     * 会员页详情
     */
    MEMBER_DETAIL_PAGE = "13",
    /**
     * 受邀记录详情
     */
    INVITE_DETAIL_PAGE = "14",
    /**
     * 查看船舶监控详情
     */
    SHIP_MONITOR_DETAIL_PAGE = "15",
    /**
     * 查看子账号列表
     */
    SUB_ACCOUNT_LIST_PAGE = "16",
    /**
     * 付款详情
     */
    PAYMENT_DETAIL_PAGE = "17",
    /**
     * 组织机构认证页
     */
    ORGANIZATION_CERTIFICATION = "18",
    /**
     * 承运商船运需求详情
     */
    TRANSFER_SHIP_REQUIRE_DETAIL_PAGE = "19",

    /** 平台回复留言后 */
    REPLY_MESSAGE_TEMPLATE = "20",
    /**
     * 油品订单详情页
     */
    OIL_ORDER_DETAIL_PAGE = "21",
    /**
     * 订单详情页
     */
    ORDER_DETAIL_PAGE = "22",
    /**
     * 团购商品列表页
     */
    PRODUCT_GROUP_PURCHASE_LIST_PAGE = "23",
    /**
     * 捡漏商品详情页
     */
    PRODUCT_BARGAIN_DETAIL_PAGE = "24",
    /**
     * 申请寄样详情页
     */
    SAMPLE_APPLY_DETAIL_PAGE = "25",
    /**
     *  提货明细详情页
     */
    DELIVERY_DETAIL_PAGE = "26",
    /**
     * 发票详情页
     */
    INVOICE_DETAIL_PAGE = "27",
    /** 
      * 供应商详情页
     */
    SUPPLIER_DETAIL_PAGE = "28",
    /**
     * 团购商品详情页
     */
    PRODUCT_GROUP_PURCHASE_DETAIL_PAGE = "29",
    /**
     * 活动报名详情页
     */
    CAMPAIGN_REGISTRATION_DETAIL_PAGE = "32" 
}
